import { $authHost } from '@/http/index'

export const deleteFile = async (filesId) => {
  return await $authHost.post('/files', { filesId })
}

export const sendError = async (formData) => {
  return await $authHost.post('/setting/error', formData)
}
